import { Button } from "react-bootstrap";
import { ReactNode } from "react";

interface Props {
    children?: ReactNode,
    className?: string,
    variant?: string,
    onClick?: () => void,
    style?: Object,
}
const AppButton: React.FC<Props> = (props) => {
    return (
        <Button className="btn btn-theme-white-noborder" variant="secondary" onClick={props.onClick} style={{backgroundImage: "url(img/ui/btn_02.png)", ...props.style}}>
            {props.children}
        </Button>
    )
}
export default AppButton